<template>
    <div v-if="fields.length" class="mounted-texts">
        <el-form-item v-for="f in fields" :key="f.value" :label="f.label">
            <TextRefSelect :model-value="(modelValue || {})[f.value] || ''" :type="f.value"
                default-placeholder="不使用" @update:model-value="onChange(f.value, $event)"></TextRefSelect>
            <div class="form-tip">文案用途「{{ f.label }}」，App 新版本按 texts.{{ f.value }} 读取</div>
        </el-form-item>
    </div>
</template>

<script>
import TextRefSelect from './TextRefSelect.vue'
import { mountedTextTypes, cleanMountedTexts, validateTextRef } from './utils'

// 挂在某类对象（分类、功能、灯效动画、复位颜色）上的文案项：每个挂载位置等于 mount 的文案用途一行
export default {
    name: 'PairingMountedTexts',
    components: { TextRefSelect },
    props: {
        // category / function / led_effect / reset_color
        mount: { type: String, required: true },
        // { 用途code: TextRef }
        modelValue: { type: Object, default: () => ({}) },
        // meta.text_types
        textTypes: { type: Array, default: () => [] },
    },
    emits: ['update:modelValue'],
    computed: {
        fields() {
            return mountedTextTypes(this.textTypes, this.mount)
        },
    },
    methods: {
        onChange(code, value) {
            this.$emit('update:modelValue', cleanMountedTexts({ ...(this.modelValue || {}), [code]: value }))
        },
        // 保存前校验：返回第一条错误信息，合法时为空串
        validate() {
            const texts = this.modelValue || {}
            for (const f of this.fields) {
                const err = validateTextRef(texts[f.value])
                if (err) return `${f.label}：${err}`
            }
            return ''
        },
    },
}
</script>

<style scoped>
.form-tip {
    font-size: 12px;
    line-height: 18px;
    color: #909399;
}
</style>
